import { ParentsTab } from '@features/parents-list/components/ParentsTab'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { meSessionQueryOptions } from '@features/me/queries'
import { normalizePermission } from '@features/rbac/permissions'

export const Route = createFileRoute('/_layout/parents')({
    component: ParentsTab,
    beforeLoad: async ({ context }) => {
        const session = await context.queryClient.ensureQueryData(meSessionQueryOptions())
        const canAccessParents = session.permissions.some((permission) =>
            ['parents.manage', 'parents.view'].includes(normalizePermission(permission)),
        )

        if (!canAccessParents) throw redirect({ to: '/unauthorised' })
    },
    staticData: {
        crumb: {
            label: 'Parents',
        },
    }
})
